import { PublicHeader } from "@/components/PublicHeader";
import { Footer } from "@/components/Footer";

export default function Privacidad() {
  return (
    <div className="min-h-screen bg-white">
      <PublicHeader />
      <main className="wrap-narrow py-12 sm:py-16">
        <p className="eyebrow mb-4">Privacidad</p>
        <h1 className="font-display text-4xl text-[var(--text)]" data-testid="privacidad-title">
          Qué hacemos con tus datos
        </h1>
        <div className="mt-8 space-y-6 text-lg text-[var(--muted)]">
          <p>
            <strong className="text-[var(--text)]">Responsable del tratamiento:</strong> Patricia
            Leung Ávalos (DNI 48304624R). Av. Dra. Damiana Zaragoza y Zaragoza, nº 3, 1º B 4, CP
            03570, Villajoyosa (Alicante). Contacto:{" "}
            <a href="mailto:info@patricialeung.com" className="text-[var(--alba-text)] underline">
              info@patricialeung.com
            </a>
            .
          </p>
          <p>
            <strong className="text-[var(--text)]">Qué guardamos:</strong> tu nombre, tu email y las
            respuestas del ejercicio de claridad (el cambio, su importancia y tu primer paso), junto
            con la fecha de tu solicitud de sesión si la pides.
          </p>
          <p>
            <strong className="text-[var(--text)]">Para qué:</strong> para enviarte tu ejercicio,
            ayudarte a continuar y gestionar tu solicitud de sesión. No los usamos para nada más ni
            se ceden a terceros.
          </p>
          <p>
            <strong className="text-[var(--text)]">Tus derechos:</strong> puedes acceder, rectificar
            o pedir la eliminación de tus datos escribiendo a{" "}
            <a href="mailto:info@patricialeung.com" className="text-[var(--alba-text)] underline">
              info@patricialeung.com
            </a>
            .
          </p>
          <p className="text-base text-[var(--faint)]">
            Este servicio no es atención psicológica ni sanitaria.
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
}
